module.exports = __webpack_public_path__ + "img/border-center-h.3c84f06d.svg";